import {axiosApi} from "@/js/axios";

const state = {
    terroristGroups: [],
    terroristGroup: {},
    terroristGroupsCount: 0,
    perPage: 28,

    // Flags
    fetchingTerroristGroups: false,
    fetchingTerroristGroup: false,
};

const getters = {
    pageCount: (state) => {
        return Math.ceil(state.terroristGroupsCount / state.perPage);
    }
};

const actions = {
    fetchTerroristGroups({state, commit, dispatch}, payload) {
        commit('SET_FETCHING_TERRORIST_GROUPS', true);

        axiosApi.get(`/api/v2/terrorist-groups`, {
            params: {
                published: true,
                orderBy: 'name',
                direction: 'ASC',
                page: payload.page ? payload.page : 1,
                perPage: state.perPage
            }
        }).then(({data}) => {
            if (data) {
                commit('SET_TERRORIST_GROUPS', data);
                commit('SET_TERRORIST_GROUPS_COUNT', data);
                resolve(data)
            }
            commit('SET_FETCHING_TERRORIST_GROUPS', false);
        }).catch(error => {
            commit('SET_FETCHING_TERRORIST_GROUPS', false);
            reject(error);
        })
    },
    fetchTerroristGroup({commit}, payload) {
        commit('SET_FETCHING_TERRORIST_GROUP', true);

        return new Promise((resolve, reject) => {
            axiosApi.get(`/api/v2/terrorist-groups/${payload.slug}`)
                .then(({data}) => {
                    if (data) {
                        console.log(data)
                        commit('SET_TERRORIST_GROUP', data);
                        resolve(data)
                    }
                    commit('SET_FETCHING_TERRORIST_GROUP', false);
                })
                .catch(error => {
                    commit('SET_FETCHING_TERRORIST_GROUP', false);
                    reject(error);
                })
        });
    },
};

const mutations = {
    SET_TERRORIST_GROUPS(state, data) {
        state.terroristGroups = data.data;
    },
    SET_TERRORIST_GROUP(state, data) {
        state.terroristGroup = data;
    },
    SET_TERRORIST_GROUPS_COUNT(state, data) {
        state.terroristGroupsCount = data.total;
    },
    SET_FETCHING_TERRORIST_GROUPS(state, value) {
        state.fetchingTerroristGroups = value;
    },
    SET_FETCHING_TERRORIST_GROUP(state, value) {
        state.fetchingTerroristGroup = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/terroristGroups.js